import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const PRODUCTS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            name: 'name',
            strain: 'strain',
            type: 'type',
            thcLevel: 'thcLevel',
            cbdLevel: 'cbdLevel',
            internalId: 'internalId',
            producerId: 'producerId',
            visibility: 'visibility'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            name: 'n',
            strain: 's',
            type: 't',
            thcLevel: 'tl',
            cbdLevel: 'cl',
            internalId: 'ii',
            producerId: 'pi',
            visibility: 'v'
        })
    })
})()
